import { Button, Card, Col, Row, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import BeianFooter from '@/components/BeianFooter'

function EntryPage() {
  const { user, token, logout } = useAuth()

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(120deg, #e6f4ff 0%, #fffbe6 100%)',
        padding: 24,
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <Card style={{ width: 820, borderRadius: 12 }}>
        <Space direction="vertical" size={18} style={{ width: '100%' }}>
          <Typography.Title level={2} style={{ margin: 0 }}>
            公司智慧管理中台
          </Typography.Title>
          <Typography.Text type="secondary">
            请选择登录入口。管理员入口与普通用户入口分离，普通用户可在用户入口自助注册。
          </Typography.Text>
          {token ? (
            <Card size="small" style={{ background: '#fffbe6' }}>
              <Space direction="vertical" size={6} style={{ width: '100%' }}>
                <Typography.Text>
                  当前已登录账号：{user?.username || '未知用户'}（{user?.is_admin ? '管理员' : '普通用户'}）
                </Typography.Text>
                <Button onClick={logout}>切换账号（先退出当前登录）</Button>
              </Space>
            </Card>
          ) : null}

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Card title="管理员入口" variant="outlined">
                <Typography.Paragraph type="secondary">
                  管理员拥有完整权限，包括用户与授权管理。
                </Typography.Paragraph>
                <Link to="/login/admin">
                  <Button type="primary" block>
                    进入管理员登录
                  </Button>
                </Link>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="普通用户入口" variant="outlined">
                <Typography.Paragraph type="secondary">
                  普通用户可登录或注册，默认开放查看权限与观察/水肥记录能力。
                </Typography.Paragraph>
                <Link to="/login/user">
                  <Button block>进入用户登录/注册</Button>
                </Link>
              </Card>
            </Col>
          </Row>
        </Space>
      </Card>
      <BeianFooter style={{ paddingBottom: 0 }} />
    </div>
  )
}

export default EntryPage
